export default __webpack_public_path__ + "static/joko-app-screenshot-home-en@2x-3aae27efd89bf5cdb3c91d49baac03b9.webp";